export const DOCS_DEBUG_KEY = 'proton-docs-debug'
export const DOCS_EDITOR_DEBUG_KEY = 'proton-docs-editor-debug'
